/* eslint-disable no-restricted-globals */
import { useEffect } from 'react';
import PropTypes from 'prop-types';
import { CloudinaryPicture, Grid, GridItem } from '@bwoty-web/ui-kit';
import TreeList from './treeList/treeList';
import './worldTreeView.scss';

const WorldTreeView = ({ selectedId, regions }) => {
  const imageSizes = [
    {
      width: 392,
      height: 522,
      breakpoint: 768,
    },
    {
      width: 686,
      height: 269,
      breakpoint: 416,
    },
    {
      width: 358,
      height: 269,
    },
  ];

  useEffect(() => {
    if (selectedId) {
      if (typeof history !== 'undefined' && 'scrollRestoration' in history) {
        // Prevent browser's automatic scrollRestoration
        history.scrollRestoration = 'manual';
      }
      // Scroll to previously selected item
      document.getElementById(`id_${selectedId}`).scrollIntoView(true);
    }
  }, [selectedId]);

  return (
    <Grid className="gw-world-tree">
      {regions?.map((region) => {
        return (
          <GridItem columnSpan={4} key={`region_${region.id}`}>
            <div>
              {(region?.defaultImage || region?.topImageCloudinary) && (
                <CloudinaryPicture
                  img={region?.topImageCloudinary || region?.defaultImage}
                  className="gw-world-tree__region-image"
                  sizes={imageSizes}
                  retina
                />
              )}
              <div className="gw-world-tree__region">
                <a href={region?.url}>
                  <h2 className="gw-world-tree__region-name">{region?.name}</h2>
                </a>
                {region?.destinations?.map((destination) => {
                  return (
                    <TreeList
                      tree={destination}
                      key={destination.id}
                      selectedId={selectedId}
                    />
                  );
                })}
              </div>
            </div>
          </GridItem>
        );
      })}
    </Grid>
  );
};

WorldTreeView.propTypes = {
  regions: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string.isRequired,
      url: PropTypes.string,
      id: PropTypes.string.isRequired,
      destinations: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
    }),
  ).isRequired,
  selectedId: PropTypes.string,
};

WorldTreeView.defaultProps = {
  selectedId: null,
};

export default WorldTreeView;
